module.exports = __webpack_public_path__ + "img/property2.551dfeb1.png";